import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"

const PROTOUNIT = {
    "randomJobKey": "sword,dagger,hammer,gun",
    "affiliation": "bad",
}

const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "y3",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": "Destroy the 2 bridges",
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript({"spotTag": "spawn-good"}),
                    "HERO: We must destroy the bridge!"
                ]
            },
            {
                "type": "turn:every-odd:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn-bad", "protounit": PROTOUNIT}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.currentEncounterKey == 1
                        && stage.units["bridge1"].isDead == true
                        && stage.units["bridge2"].isDead == true
                },
                "events": [
                    (stage) => {
                        return {
                            "name": "SavestateCapture",
                            "savestateSlug": "winChapter_" + stage.chapterSlug,
                        }
                    },
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war/chapters/y4")},
                ]
            },
            PlotScripts.ChapterFailure(),
        ]
    },
}
